import styled from "styled-components";

import { Card } from "@/components/molecules";

export const StyledClosedClaimCard = styled(Card)`
    min-height: 80px;
    .bodyWrapperWithCompanyIcon {
        padding-left: 16px;
    }
`;
